import { useMutation, useQueryClient } from '@tanstack/react-query';

import { globalNotificationService } from '@/services/global_notification.service';

const useDeleteGlobalNotificaiton = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (notificationId: number) =>
			await globalNotificationService.deleteGlobalNotifications(notificationId),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['global-notification'] });
		},

		onError: () => {
			throw new Error('Error deleting global notification');
		},
	});
};

export default useDeleteGlobalNotificaiton;
